import React from 'react'
import { useDispatch } from 'react-redux'
import flowRight from 'lodash/flowRight'
import includes from 'lodash/includes'
import find from 'lodash/find'
import { useSetState } from 'react-nb-hooks'
import { LKDate } from 'loankeeper-common/helpers/Date'
import transformProps from 'loankeeper-common/containers/transformProps'
import withCallAPI from 'loankeeper-common/containers/withCallAPI'

import { getClientReqFields, getClientSelects, loadClientCashDocs, loadClientLinkedFiles } from '../../../store/client'
import { LKModalContainer } from '../../shared/LKModal'
import withLivedata from '../../shared/containers/withLivedata'
import commonContainers from '../containers/common'

import { reduxFormContainer } from './addContainers'
import { connect } from 'react-redux'
import { accEntryViewConv, accEntryViewConventries } from 'src/store/accEntry'
import { accountViewBalance } from 'src/store/account'

const initialClientData = {
  loading: false,
  idDocs: undefined,
  linkedFiles: undefined,
}

const withClientData = (Component) => (props) => {
  const dispatch = useDispatch()

  const [state, setState] = useSetState(initialClientData)

  const {
    name,
    OperTypeID,
    clientDetails: { ClientID: clientId, HashSum_ClientID_: clientHash },
  } = props

  React.useEffect(() => {
    if (includes(['OrderConvertInCashCopy', 'OrderConvertInCashEdit'], name) && OperTypeID === 7 && clientId === 0) {
      setState(initialClientData)
      return
    }

    async function loadData() {
      setState({
        ...initialClientData,
        loading: true,
      })

      const [clientCashDocsResult, clientLinkedFilesResult] = await Promise.all([
        dispatch(
          loadClientCashDocs({
            clientId,
            clientHash,
          }),
        ),
        dispatch(
          loadClientLinkedFiles({
            clientId,
            clientHash,
          }),
        ),
      ])

      const nextState = initialClientData

      if (loadClientCashDocs.fulfilled.match(clientCashDocsResult)) {
        nextState.idDocs = clientCashDocsResult.payload
      }

      if (loadClientLinkedFiles.fulfilled.match(clientLinkedFilesResult)) {
        nextState.linkedFiles = clientLinkedFilesResult.payload
      }

      setState(nextState)
    }

    loadData()
  }, [dispatch, setState, name, OperTypeID, clientId, clientHash])

  return <Component {...props} iddocs={state.idDocs} linkedfiles={state.linkedFiles} />
}

const commonConvContainers = flowRight(
  LKModalContainer(),

  commonContainers,

  withLivedata(['CCYCommercialRates', 'CCYOfficalRates']),
  connect(undefined, (dispatch) => ({
    accEntryViewConv: (params) => dispatch(accEntryViewConv(params)),
    accountViewBalance: (params) => dispatch(accountViewBalance(params)),
  })),
  // withCallAPI({
  //   APICall: (params) => Order.details,
  //   APIParams: ({ params }) => ({
  //     ID: params.ID,
  //     hash: params.hash,
  //     OID: params.OID,
  //     HashSum_OID_: params.OIDHash,
  //     page: 'viewconv',
  //   }),
  //   transformData: (response) => ({ details: response.Data }),
  //   withLoading: true,
  // }),

  //UPDATED API REQUEST acc_entry_view_api page: 'viewconv'
  (Component) => {
    class WrappedContainer extends React.Component {
      constructor(props) {
        super(props)
        this.Wrapped = withCallAPI({
          APICall: (params) => props.accEntryViewConv(params),
          APIParams: ({ params }) => ({
            EntryID: params.ID,
            HashSum_EntryID_: params.hash,
            OID: params.OID,
            HashSum_OID_: params.OIDHash,
            page: 'viewconv',
          }),
          transformData: ({ payload: response }) => ({ details: response }),
          withLoading: true,
        })(Component)
      }

      render() {
        const { Wrapped } = this

        return <Wrapped {...this.props} />
      }
    }

    return WrappedContainer
  },

  // withCallAPI({
  //   APICall: [Account.details, Account.details],
  //   APIParams: [
  //     ({ details }) => ({ ID: details.DAccID, hash: details.HashSum_DebitAccID_, page: 'balance' }),
  //     ({ details }) => ({ ID: details.CAccID, hash: details.HashSum_CreditAccID_, page: 'balance' }),
  //   ],
  //   transformData: [
  //     (response) => ({ debitBalance: response.Data.Balance }),
  //     (response) => ({ creditBalance: response.Data.Balance }),
  //   ],
  //   withLoading: true,
  // }),

  // acc_account_view_api page: balance
  (Component) => {
    class WrappedContainer extends React.Component {
      constructor(props) {
        super(props)
        this.Wrapped = withCallAPI({
          APICall: [(params) => props.accountViewBalance(params), (params) => props.accountViewBalance(params)],
          APIParams: [
            ({ details }) => ({ AccountID: details.DAccID, HashSum_AccountID_: details.HashSum_DebitAccID_ }),
            ({ details }) => ({ AccountID: details.CAccID, HashSum_AccountID_: details.HashSum_CreditAccID_ }),
          ],
          transformData: [
            ({ payload }) => ({ debitBalance: payload.Balance }),
            ({ payload }) => ({ creditBalance: payload.Balance }),
          ],
          withLoading: true,
        })(Component)
      }

      render() {
        const { Wrapped } = this

        return <Wrapped {...this.props} />
      }
    }

    return WrappedContainer
  },
)

const commonConvContainersForm = flowRight(
  transformProps((props) => {
    const newProps = {
      ...props,

      checkDebitAccountFetcherName: 'checkDebitAccountFetcherName',
      checkCreditAccountFetcherName: 'checkCreditAccountFetcherName',

      initialValues: {
        action: props.copy ? 'add' : 'edit',

        DebitAccNo: props.details.DAccNo,
        DebitChosenAccNo: props.details.DAccNo,
        DebitAccID: props.details.DAccID,
        DebitAccHash: props.details.HashSum_DebitAccID_,
        DebitTitleUNI: props.details.DAccTitleUNI,
        DebitAccBalance: props.debitBalance,

        CreditAccNo: props.details.CAccNo,
        CreditChosenAccNo: props.details.CAccNo,
        CreditAccID: props.details.CAccID,
        CreditAccHash: props.details.HashSum_CreditAccID_,
        CreditTitleUNI: props.details.CAccTitleUNI,
        CreditAccBalance: props.creditBalance,

        EntryID: props.details.EntryID1,
        HashSum_EntryID_: props.details.HashSum_EntryID_,
        OID: props.details.OID,
        HashSum_OID_: props.details.HashSum_OID_,
        debitCCY: props.details.CCYA,
        creditCCY: props.details.CCYB,
        buyACheck: '1',
        sellBCheck: '0',
        buyAmountA: props.copy ? 0 : props.details.AmountA,
        sellAmountB: props.copy ? 0 : props.details.AmountB,
        alreadyDefinedRates: '1',
        ccyBuyRate: parseFloat(props.details.Rate2),
        ccySellRate: parseFloat(props.details.Rate1),
        CCYRateType: 'commercial',
        OpCodeID: props.details.OpCodeID,
        DocNo: props.copy ? '' : props.details.DocNo,
        DocDate: props.copy ? props.OpenDay : LKDate.from(props.details.DocDate).toString(),
        Comment: props.details.Comment,
        Authorize: props.params.Authorize === 1 || props.params.Authorize === 2 ? 1 : 0,
      },
    }

    if (props.OperTypeID === 7) {
      let IDDoc = props.iddocs && find(props.iddocs, (d) => d.IDNumber === props.clientDetails.OtherIDNumber)

      if (!IDDoc) {
        IDDoc = props.iddocs && find(props.iddocs, (d) => d.DFDoc === 1)
      }

      return {
        ...newProps,
        initialValues: {
          ...newProps.initialValues,

          clientID: newProps.clientDetails.ClientID,
          clientHash: newProps.clientDetails.HashSum_ClientID_,
          clientIsChosen: !!newProps.clientDetails.ClientID,

          IDDoc,
          LinkedFiles: props.linkedfiles,

          Name: newProps.clientDetails.Name,
          Surname: newProps.clientDetails.Surname,
          CityID: newProps.clientDetails.CityID,
          Address: newProps.clientDetails.Address,
          ClientType: newProps.clientDetails.ClientType.toString(),
          DOB:
            newProps.clientDetails.DOB === '1900-01-01 00:00:00'
              ? ''
              : LKDate.from(newProps.clientDetails.DOB).toString(),
          DOBCheck:
            props.requiredFields && props.requiredFields.IND_DOB && props.requiredFields.IND_DOB.Active === 1
              ? '1'
              : '0',
          MobileNumber: props.clientDetails.CellPhone,
          IDCardTypeID: props.clientDetails.IDCardTypeID,
          CardNumber: props.clientDetails.CardNumber,
          OtherIDNumber: props.clientDetails.OtherIDNumber,
          IDCardIssuerID: props.clientDetails.IDCardIssuerID,
          IDCardRegDate:
            newProps.clientDetails.IDCardRegDate === '1900-01-01 00:00:00'
              ? props.OpenDay
              : LKDate.from(newProps.clientDetails.IDCardRegDate).toString(),
          IDCardRegDateCheck:
            props.requiredFields &&
            props.requiredFields.IDCardRegDate &&
            props.requiredFields.IDCardRegDate.Active === 1
              ? '1'
              : '0',
          IDValidityDate:
            newProps.clientDetails.IDValidityDate === '1900-01-01 00:00:00'
              ? props.OpenDay
              : LKDate.from(newProps.clientDetails.IDValidityDate).toString(),
          IDValidityDateCheck:
            props.requiredFields &&
            props.requiredFields.IDValidityDate &&
            props.requiredFields.IDValidityDate.Active === 1
              ? '1'
              : '0',
          AddUserInDB: '0',
          CitizenshipID: 1,
          MoneyTransferCountryID: props.clientSelects && props.clientSelects.Country[0].ID,
        },
      }
    }

    return newProps
  }),

  reduxFormContainer,
)

export const convertOnAccountEditContainers = flowRight(commonConvContainers, commonConvContainersForm)

export const convertInCashEditContainers = flowRight(
  commonConvContainers,
  connect(undefined, (dispatch) => ({
    getClientReqFields: (params) => dispatch(getClientReqFields(params)),
    getClientSelects: (params) => dispatch(getClientSelects(params)),
    accEntryViewConventries: (params) => dispatch(accEntryViewConventries(params)),
  })),

  // withCallAPI({
  //   APICall: (params) => {
  //     console.log(params)
  //     debugger;
  //     return Order.details(params)
  //   },
  //   APIParams: ({ details }) => ({
  //     ID: details.EntryID1,
  //     hash: details.HashSum_EntryID_,
  //     page: 'viewdetails',
  //   }),
  //   transformData: ({ Data: clientDetails }) => ({ clientDetails }),
  //   withLoading: true,
  // }),
  //UPDATED API REQUEST acc_entry_view_api page: 'viewdetails'
  (Component) => {
    class WrappedContainer extends React.Component {
      constructor(props) {
        super(props)
        console.log(props)
        this.Wrapped = withCallAPI({
          APICall: (params) => props.accEntryViewConventries(params),
          APIParams: ({ details }) => ({
            EntryID: details.EntryID1,
            HashSum_EntryID_: details.HashSum_EntryID_,
            page: 'viewdetails',
          }),
          transformData: ({ payload: clientDetails }) => ({ clientDetails }),
          withLoading: true,
        })(Component)
      }

      render() {
        const { Wrapped } = this

        return <Wrapped {...this.props} />
      }
    }

    return WrappedContainer
  },

  (Component) => {
    const WrappedReqFields = (props) => {
      const { name, OperTypeID, clientDetails } = props
      const NewComp = React.useMemo(() => {
        if (
          includes(['OrderConvertInCashCopy', 'OrderConvertInCashEdit'], name) &&
          OperTypeID === 7 &&
          clientDetails.ClientID === 0
        ) {
          return <Component {...props} />
        }

        const Wrapper = withCallAPI({
          APICall: [
            // Client.getSelects,
            //UPDATED API REQUEST client_lookups_api
            (params) => props.getClientSelects(params),
            // Client.getRequiredFields,
            //UPDATED API REQUEST client_reqfields_api
            (params) => props.getClientReqFields(params),
          ],
          APIParams: [undefined, () => ({ groupid: 9, typeid: 1 })],
          transformData: [
            // (response) => ({ clientSelects: response.Data }),
            //UPDATED API REQUEST client_lookups_api
            ({ payload: response }) => ({ clientSelects: response }),
            // (response) => {
            //UPDATED API REQUEST client_reqfields_api
            ({ payload: response }) => ({
              requiredFields: response.ReqFields.reduce(
                (result, current) => ({
                  ...result,
                  [current.FName]: current,
                }),
                {},
              ),
            }),
          ],
          withLoading: true,
        })(Component)

        return <Wrapper {...props} />

        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [name, OperTypeID, clientDetails.ClientID])

      return NewComp
    }

    return WrappedReqFields
  },

  withClientData,

  commonConvContainersForm,
)
